module.exports = __webpack_public_path__ + "img/Frame2.89527d9c.png";